import React from "react";
import PropTypes from "prop-types";
import humps from "humps";
import { Button } from "cxa-components";
import SmokingIcon from "assets/images/icon/icon-smoking.svg";
import ActivityIcon from "assets/images/icon/icon-activity.svg";
import ScreeningIcon from "assets/images/icon/icon-screening.svg";
import NutritionIcon from "assets/images/icon/icon-nutrition.svg";
import StressIcon from "assets/images/icon/icon-stress.svg";
import BodyFatIcon from "assets/images/icon/icon-body-fat.svg";
import PainIcon from "assets/images/icon/icon-pain.svg";
import AlcoholIcon from "assets/images/icon/icon-alcohol.svg";
import SleepIcon from "assets/images/icon/icon-sleep.svg";
import MentalHealthIcon from "assets/images/icon/icon-mental-health.svg";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const viewAgingDefaultImage = "assets/images/wellness/view_aging_default.png";
const sampleLifestyle = "assets/images/wellness/sample_lifestyle.jpg";

const icons = {
  SmokingIcon: <SmokingIcon />,
  ActivityIcon: <ActivityIcon />,
  ScreeningIcon: <ScreeningIcon />,
  NutritionIcon: <NutritionIcon />,
  StressIcon: <StressIcon />,
  BodyFatIcon: <BodyFatIcon />,
  PainIcon: <PainIcon />,
  AlcoholIcon: <AlcoholIcon />,
  SleepIcon: <SleepIcon />,
  MentalHealthIcon: <MentalHealthIcon />,
};

const RiskItem = ({ name, riskLevel, icon, intl }) => (
  <li className={`grid__item risk-item--${riskLevel}`}>
    <div>
      <div className="risk__description screenreader-only">{riskLevel}</div>
      {icon}
      <p>{intl.formatMessage({ id: name, defaultMessage: name })}</p>
    </div>
  </li>
);

// Do a Health Assessment
// & Age Your Face Now

const HealthReview = injectIntl(
  ({ assessmentStatus, healthyPhotos, unhealthyPhotos, userHealthRiskScore, intl }) => {
    const { formatMessage } = intl;
    const attributes = [
      "Smoking",
      "Activity",
      "Screening",
      "Nutrition",
      "Stress",
      "Body Fat",
      "Pain",
      "Alcohol",
      "Sleep",
      "Mental Health",
    ];

    const data = attributes.map(attr => {
      if (userHealthRiskScore && userHealthRiskScore[`${humps.camelize(attr)}RiskClass`]) {
        return {
          name: attr,
          riskLevel: userHealthRiskScore[`${humps.camelize(attr)}RiskClass`],
          icon: icons[`${humps.pascalize(attr)}Icon`],
        };
      }

      return {
        name: attr,
        riskLevel: "",
        icone: "",
      };
    });
    const healthyLifestyle = healthyPhotos ? `${healthyPhotos}` : viewAgingDefaultImage;
    const currentLifestyle = unhealthyPhotos ? `${unhealthyPhotos}` : viewAgingDefaultImage;

    let section;
    let footer;

    if (assessmentStatus && assessmentStatus.hraQuestionsAnswered === "true") {
      section = (
        <section className="apl-dashboard__lifestyle">
          <div className=" grid__wrapper">
            <figure className="grid__item lifestyle__photo">
              <div>
                <img src={currentLifestyle} alt="Current Lifestyle" />
                <p>
                  <strong>{formatMessage(messages.currentLifestyleDescription)}</strong>
                </p>
              </div>
            </figure>
            <figure className="grid__item lifestyle__photo">
              <div>
                <img src={healthyLifestyle} alt="Healty Lifestyle" />
                <p>
                  <strong>{formatMessage(messages.healthyLifestyleDescription)}</strong>
                </p>
              </div>
            </figure>
            <div className="grid__item lifestyle__risk">
              <ul className="grid__wrapper">
                {data &&
                  data.map(
                    (item, idx) =>
                      item && <RiskItem {...item} key={`riskItem_${idx}`} intl={intl} />
                  )}
              </ul>
            </div>
          </div>
        </section>
      );
      footer = (
        <Button to="wellness/lifestyleAgeing/results" secondary>
          {formatMessage(messages.reviewNowDescription)}
        </Button>
      );
    } else {
      section = (
        <section className="lifestyle dashboard__lifestyle">
          <figure>
            <img className="lifestyle__photo" src={sampleLifestyle} alt="Sample Lifestyle" />
          </figure>
        </section>
      );
      footer = (
        <Button to="/wellness/lifestyleAgeing/ageYourSelf" secondary>
          {formatMessage(messages.faceAgingDescription)}
        </Button>
      );
    }

    return (
      <article className="card">
        <header>
          <h2>{formatMessage(messages.healthReviewDashboardDescription)}</h2>
        </header>
        {section}
        <footer>{footer}</footer>
      </article>
    );
  }
);

HealthReview.propTypes = {
  assessmentStatus: PropTypes.object,
  healthyPhotos: PropTypes.string,
  unhealthyPhotos: PropTypes.string,
  userHealthRiskScore: PropTypes.object,
};

RiskItem.propTypes = {
  name: PropTypes.string,
  riskLevel: PropTypes.string,
  icon: PropTypes.object,
  intl: intlShape.isRequired,
};

export default HealthReview;



// WEBPACK FOOTER //
// ./components/dashboard/HealthReview.js